// @ts-nocheck
//自定义组件
import Vue from 'vue'

//swiper组件
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper)



import '@/styles/styles.scss';
// import TWEEN from '@tweenjs/tween.js'


// import RecordCard from '@/components/RecordCard/RecordCard.vue';
// Vue.component(RecordCard.name, RecordCard);

// import PeopleList from '@/components/PeopleList/PeopleList.vue';
// Vue.component(PeopleList.name, PeopleList);

// import OInput from '@/components/OInput/OInput.vue';
// Vue.component(OInput.name, OInput);

// import OHighTitle from '@/components/OHighTitle/OHighTitle.vue';
// Vue.component(OHighTitle.name, OHighTitle);

// import OTabNav from '@/components/OTabNav/OTabNav.vue';
// Vue.component(OTabNav.name, OTabNav);

// import OLine from '@/components/OLine/OLine.vue';
// Vue.component(OLine.name, OLine);

// import OTop from '@/components/OTop/OTop.vue';
// Vue.component(OTop.name, OTop);

// import SelectClass from '@/components/SelectClass/SelectClass.vue';
// Vue.component(SelectClass.name, SelectClass);

// 区域选择

// import RArea from '@/components/RArea/RArea.vue';
// Vue.component(RArea.name, RArea);

  


// Vue.prototype.$is = function (fun, type, title) {
//     if (!title) {
//         title = "此操作将永久删除此数据, 是否继续?";
//     }
//     if (!type) {
//         type = "warning";
//     }
//     this.$confirm(title, "提示", {
//         confirmButtonText: "确定",
//         cancelButtonText: "取消",
//         type: type
//     })
//         .then(() => {
//             fun();
//         })
//         .catch(() => { });
// }


/**
     * 
     * 产生随机字符串，不长于32位
     * @param int $length
     * @return 产生的随机字符串
     */
Vue.prototype.$getNonceStr = function (length = 32) {

    let chars = "abcdefghijklmnopqrstuvwxyz0123456789";
    let str = "";
    for (let i = 0; i < length; i++) {
        var random = Math.floor(Math.random() * chars.length);
        str += chars[random];
    }
    return str;
}

//复制内容
Vue.prototype.$copy = function (str) {

    // var oInput = document.createElement('input');
    // oInput.value = str;
    // document.body.appendChild(oInput);
    // oInput.select(); // 选择对象
    // document.execCommand("Copy"); // 执行浏览器复制命令
    // document.body.removeChild(oInput);
    // this.$info('复制成功~');

}


//查看二维码
Vue.prototype.$qrcode = function (url) {

    // url = encodeURIComponent(url);
    // let qrcodeUrl = this.$serverHome + 'Qrcode/getCode?value=' + url;
    // window.open(qrcodeUrl);

}
dynamicComp();
function dynamicComp() {
    // ======================================================新组件注册

    // HelloWorld   
    // Vue.component('HelloWorld', require(`../components/HelloWorld.vue`));
    const requireComponent = require.context(
        // 其组件目录的相对路径
        '../components',
        // 是否查询其子目录
        true,
        // 匹配基础组件文件名的正则表达式
        /[A-Z]\w+\.(vue)$/
    )

    requireComponent.keys().forEach(fileName => {
        // 获取组件配置
        const componentConfig = requireComponent(fileName)
        const componentName = componentConfig.default.name
        // // 全局注册组件

        Vue.component(
            componentName,
            // 如果这个组件选项是通过 `export default` 导出的，
            // 那么就会优先使用 `.default`，
            // 否则回退到使用模块的根。
            componentConfig.default || componentConfig
        )
    })

}


// Vue.component('animated-integer', {
//     render(h) {
//         return h('span', this.tweeningValue);
//     },
//     props: {
//         value: {
//             type: Number,
//             required: true
//         }
//     },
//     data: function () {
//         return {
//             tweeningValue: 0
//         }
//     },
//     watch: {
//         value: function (newValue, oldValue) {
//             this.tween(oldValue, newValue)
//         }
//     },
//     mounted: function () {
//         this.tween(0, this.value)
//     },
//     methods: {
//         tween: function (startValue, endValue) {
//             var vm = this
//             function animate() {
//                 if (TWEEN.update()) {
//                     requestAnimationFrame(animate)
//                 }
//             }
//             new TWEEN.Tween({ tweeningValue: startValue })
//                 .to({ tweeningValue: endValue }, 500)
//                 .onUpdate(function (object) {
//                     vm.tweeningValue = object.tweeningValue.toFixed(0)
//                 })
//                 .start()

//             animate()
//         }
//     }
// })
